import React from 'react';

export const { Fragment } = React;

function withKey(props, key) {
  if (key === undefined || (props && Object.prototype.hasOwnProperty.call(props, 'key'))) {
    return props || {};
  }

  return { ...props, key };
}

export function jsx(type, props, key) {
  return React.createElement(type, withKey(props, key));
}

export const jsxs = jsx;
export const jsxDEV = jsx;
